<template>
  <div>
    <PageHeader :title="title" :items="headerItems" />
    <div class="main">
      <b-row>
        <b-col cols="12">
          <div class="inner__style">
            <div>
              <div class="d-flex align-items-center mb-3 p-0">
                <div class="d-flex align-items-center">
                  <span class="sectionTitle">اطلاعات رنگ</span>
                </div>
                <div class="line"></div>
              </div>
              <div class="section">
                <div class="mb-3">
                  <BaseText @input="colorName = $event" :value="colorName" title="نام" placeholder="نام" />
                </div>
                <div class="">
                  <ColorPicker @input="selectedColor = $event" :value="selectedColor" title="رنگ" />
                </div>
              </div>
              <div class="buttonClass">
                <Button @click.native="submit" text="ثبت" btnClass="ms-2 aprove btn-border" :loading="btnLoading" />
                <b-button @click="cancelModal = true" class="cancleButton">
                  <span class="cancleTitle">انصراف</span>
                </b-button>
                <b-modal v-model="cancelModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
                  <div class="error-wrapper">
                    <div class="mb-4">
                      <img src="@/assets/images/checked1.svg" />
                    </div>
                    <div class="error-title">
                      آیا از انصراف خود مطمئن هستید؟
                    </div>
                    <div class="buttons">
                      <button @click.native="cancelModal = false" class="cancelButton">خیر</button>
                      <div
                        @click="
                          cancelModal = false
                          $router.go(-1)
                        "
                      >
                        <button class="approveButton">بلی</button>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import BaseText from '../../common/form/formModules/BaseText.vue'
import ColorPicker from '../../common/form/formModules/colorPicker.vue'
import productAdvanceDataProvider from '../../../services/productAdvance'
import Button from '../../common/Button.vue'

export default {
  components: {
    PageHeader,
    BaseText,
    ColorPicker,
    Button,
  },
  data() {
    return {
      btnLoading: false,
      colorName: '',
      selectedColor: '#837499',
      colorId: null,
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'اضافه کردن رنگ جدید',
          active: true,
        },
      ],
      cancelModal: false,
      title: 'اضافه کردن رنگ',
    }
  },
  methods: {
    submit() {
      this.btnLoading = true
      if (this.$route.params.id) {
        productAdvanceDataProvider
          .editColor({
            id: this.$route.params.id,
            name: this.colorName,
            code: this.selectedColor,
          })
          .then(res => {
            this.btnLoading = false
            
            this.$router.push({
              path: '/list/color',
            })
          })
      } else {
        productAdvanceDataProvider
          .addColor({
            name: this.colorName,
            colorCode: this.selectedColor,
          })
          .then(res => {
            this.btnLoading = false
            
            this.$router.push({
              path: '/list/color',
            })
          })
      }
    },
  },
  mounted() {
    if (this.$route.params.id) {
      productAdvanceDataProvider.getColorDetail({ id: this.$route.params.id }).then(res => {
        const response = res.data.data
        this.colorName = response.name
        this.selectedColor = response.code
        this.colorId = response.id
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.main {
  background: #f8f8fb;
  border-radius: 8px;
}
.inner__style {
  background-color: white;
  padding: 23px;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.btn-border {
  border-radius: 4px !important;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}
.submitButton {
  font-size: 14px;
  padding: 8px 45px;
  color: white;
  background: #556ee6;
  border: 1px solid #556ee6;
  box-sizing: border-box;
  border-radius: 4px;
}
.cancleButton {
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}

.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px;
    margin-left: 12px;
    color: white;
    background: #74788d;
    border-radius: 4px;
  }
}
</style>
